import { aG as a, bn as n, aS as o, ax as e } from "./StickyHeaderSkeleton-884fa97b.mjs";
function t(r) {
  const {
    lang: s
  } = a();
  return n({
    url: o(e.CLIENT_V1_MY_CATEGORY),
    queryKey: [e.CLIENT_V1_MY_CATEGORY, {
      lang: s
    }],
    options: {
      suspense: !1,
      useErrorBoundary: !1,
      ...r
    }
  });
}
export {
  t as u
};
